import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { CreateSignupOrganisationDTO } from '@portal-front-end/models';
import { PORTAL_API_ROOT_URL } from '../constants';
import { API_SERVER_TOKEN } from '../api-server-token';


@Injectable({ providedIn: 'root' })

export class SignUpApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly SIGNUP_API_URL = `${this.apiServer}/signup`;

    createSignup(parentId: string, signup: CreateSignupOrganisationDTO): Observable<CreateSignupOrganisationDTO> {
        return this.http.post<CreateSignupOrganisationDTO>(`${this.SIGNUP_API_URL}`, signup, {
            params: {
                'parentOrganisationId' : parentId
            }
        });
    }
}
